export default (number) => {
  number = Number(number)
  number = number.toString()
  let numberSplit = number.split('.')
  let money = ''
  let c = 0
  for(var i = numberSplit[0].length-1 ; i >= 0; i--) {
    if(c%3==0 && c>0){
      money = numberSplit[0][i] + "." + money
    } else{
      money = numberSplit[0][i] + money
    }
    c++
	}
  return money
}